import {
  GETALLCUSTOMERDETAILFORSALON,
  GETALLCUSTOMERDETAILFORSALONXLSX,
  LASTSERVICEDETAILS,
  GETALLCUSTOMERDETAILS,
} from "../../utils/api";
import axios from "../../utils/axios";

export const getAllCustomerDetail = async (payoad, callback) => {
  await axios
    .post(GETALLCUSTOMERDETAILFORSALON, payoad)
    .then((res) => {
      console.log("res search ", res);
      callback(res.data.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getAllCustomerDetailXlsx = async (param, options) => {
  const res = await axios.post(
    GETALLCUSTOMERDETAILFORSALONXLSX,
    param,
    options
  );

  return res;
};

export const getLastDetail = async (payoad, callback) => {
  await axios
    .post(LASTSERVICEDETAILS, payoad)
    .then((res) => {
      console.log("res search ", res);
      callback(res.data.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAllCustomerDetails = async (payoad, callback) => {
  await axios
    .post(GETALLCUSTOMERDETAILS, payoad)
    .then((res) => {
      console.log("res search ", res);
      callback(res.data.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
